// extracted by mini-css-extract-plugin
export default {"root":"MessageBanner_root__m3XtY"};